export default function TestPage() {
  function methodDoesNotExist() {
    console.log("This method does not exist");
    throw new Error("This method does not exist");
  }

  return <button onClick={() => methodDoesNotExist()}>Break the world</button>;
}